import { FC } from 'react';
import { Trans, useTranslation } from 'next-i18next';
import PitchPageLayout from 'src/common/components/PitchPageLayout';
import Typography from 'src/common/components/Typography';
import { StickerCategories, StickerConfig } from 'src/common/components/Sticker/stickerMap';
import StickersHeader from 'src/common/components/StickersHeader';
import SearchHero from 'src/common/components/Search/SearchHero';
import styles from './Hero.module.scss';

type HeroProps = {
  headerStickers?: Record<StickerCategories, StickerConfig> | null;
};

const Hero: FC<HeroProps> = ({ headerStickers }) => {
  const [t] = useTranslation('home-page');

  return (
    <PitchPageLayout
      backgroundColor="ivory"
      outerChildren={(
        <div className={styles.searchBar}>
          <SearchHero variant="hero" />
        </div>
      )}
      variant="headerWithSearch"
    >
      <div className={styles.root}>
        {headerStickers && (
          <StickersHeader
            stickerAction={headerStickers.actions}
            stickerBoat={headerStickers.boats}
            stickerThing={headerStickers.things}
            i18nKey="make-it-a-boat-day"
            translationFunction={t}
          />
        )}
        <div className={styles.subTitle}>
          <Typography type="h1" size="body-xl">
            <Trans
              t={t}
              i18nKey="hero--subtitle"
              components={{
                break: (
                  <br className={styles.break} />
                ),
              }}
            />
          </Typography>
        </div>
      </div>
    </PitchPageLayout>
  );
};

export default Hero;
